//import React from 'react';
//import moment from 'moment';

function _adviserDahsboardBodyInDetail(props) {
    let commissionDetails = null;
    let total = null;
    let products = [];
    let numAdvisers = null;
    let advisers = props.advisers.filter(adviser => adviser.adviserId === props.selectedAdviserId).map(adviser => adviser)

    // When the adviser is not selected and in login page
    if ((props.groupLogin && (!props.selectedAdviserId || props.selectedAdviserId === -1 || props.selectedAdviserId.length > 1 ||
        String(props.history.location.pathname).includes("login"))) || !props.groupLogin) {
        commissionDetails = props.advisers.map(adviser => adviser.commission)
        total = props.total ? props.total.total : props.advisers.map(adviser => adviser.total)
        props.total ? products = props.total.products : props.advisers.map(adviser => adviser.products.map(product => products.push(product)));
        numAdvisers = props.advisers.length;
    }
    //when the adviser is selected and in anwhere 
    else {
        commissionDetails = advisers.map(adviser => adviser.commission)
        total = advisers.map(adviser => adviser.total)
        advisers.map(adviser => adviser.products.map(product => products.push(product)));
        numAdvisers = advisers.length;
    }
    return {
        commissionDetails: commissionDetails,
        total: total,
        products: products,
        numAdvisers: numAdvisers
    }
}

function _totalMembersInDetail(props) {
    let products = [];
    let productMembers = [];
    let totalMembers = 0;
    let invest = 0;
    let kiwiSaver = 0;
    let ukPension = 0;

    props.products.map(product => products.push(product));
    products.map(product => {
        const memberDetails = {
            name: product.description,
            code: product.code,
            members: product.numMembers
        }
        productMembers.push(memberDetails)
    })
    // if (props.numAdvisers > 1) {
        totalMembers = !props.total.numMembers ? props.total[0].numMembers : props.total.numMembers;
        invest = props.products.filter(product => product.code === "SLI").map(product => product.numMembers)
        kiwiSaver = props.products.filter(product => product.code === "SLKS").map(product => product.numMembers)
        ukPension = props.products.filter(product => product.code === "SLUK").map(product => product.numMembers)
    // }
    // else {
    //     totalMembers = props.total.map(total => total.numMembers);
    //     invest = props.products.map(products => products.filter(product => product.code === "SLI").map(prod => prod.numMembers));
    //     kiwiSaver = props.products.map(products => products.filter(product => product.code === "SLKS").map(prod => prod.numMembers));
    //     ukPension = props.products.map(products => products.filter(product => product.code === "SLUK").map(prod => prod.numMembers));
    // }
    return {
        totalMembers: totalMembers,
        invest: invest,
        kiwiSaver: kiwiSaver,
        ukPension: ukPension,
        productMembers: productMembers
    }
}

function _totalFumInDetail(props) {
    let products = [];
    let productFum = [];
    let totalFum = 0.00;
    let invest = 0.00;
    let kiwiSaver = 0.00;
    let ukPension = 0.00;

    props.products.map(product => products.push(product))
    products.map(product => {
        const fumDetails = {
            name: product.description,
            code: product.code,
            fum: product.fum
        }
        productFum.push(fumDetails)
    })
    // if (props.numAdvisers > 1) {
        totalFum = !props.total.fum ? props.total[0].fum : props.total.fum;
        invest = props.products.filter(product => product.code === "SLI").map(product => product.fum)
        kiwiSaver = props.products.filter(product => product.code === "SLKS").map(product => product.fum)
        ukPension = props.products.filter(product => product.code === "SLUK").map(product => product.fum)
    // }
    // else {
    //     totalFum = props.total.map(total => total.fum);
    //     invest = props.products.map(products => products.filter(product => product.code === "SLI").map(prod => prod.fum))
    //     kiwiSaver = props.products.map(products => products.filter(product => product.code === "SLKS").map(prod => prod.fum))
    //     ukPension = props.products.map(products => products.filter(product => product.code === "SLUK").map(prod => prod.fum))
    // }

    return {
        totalFum: totalFum,
        invest: invest,
        kiwiSaver: kiwiSaver,
        ukPension: ukPension,
        productFum: productFum
    }
}

function _commissionPaymentDetails(props) {
    const commissionDetails = props.commissionDetails;
    const current = Object.keys(commissionDetails).map(key => commissionDetails[key].Current);
    const previous = Object.keys(commissionDetails).map(key => commissionDetails[key].Previous);
    let currentFee = 0;
    let previousFee = 0;
    current.map(current =>
        currentFee = Number(currentFee) + Number(current.payment))
    previous.map(previous => 
        previousFee = Number(previousFee) + Number(previous.payment))
    return {
        current: current,
        currentFee: currentFee,
        previous: previous,
        previousFee: previousFee
    }
}

function _commissionPaymentDetailsGroup(props) {
    const commissionPayments = props.commissionPayments;

    const pastCommission = commissionPayments.reduce((acc, obj) => {
        // console.log(acc)
        // console.log(obj)
        for (let name in obj) {
            if (name !== "Current" && name !== "Previous"){
                if (acc[name]) {
                    acc[name].payment += obj[name].payment;
                } else {
                    acc[name]={
                        name, 
                        payment: obj[name].payment, 
                        month: obj[name].month,
                        startDate: obj[name].startDate,
                        dueDate: obj[name].dueDate };
                }
            }   
            
        }
        return acc;
    }, {});


    //const commission = commissionPayments.map(item => Object.entries(item).map(field => field[1]));
    const current = Object.keys(commissionPayments).map(key => commissionPayments[key].Current);
    const previous = Object.keys(commissionPayments).map(key => commissionPayments[key].Previous);
    //const currentStartDate = moment(current[0].startDate).format('DD-MM-YYYY')
    //const formattedDate = moment(currentStartDate).format('YYYY-MM-DD')
    let currentAmount = 0;
    current.map(current =>
        currentAmount = Number(currentAmount) + Number(current.payment))
    let previousAmount = 0;
    previous.map(previous =>
        previousAmount = Number(previousAmount) + Number(previous.payment))

    return {
        current: current,
        previous: previous,
        currentFee: currentAmount,
        previousFee: previousAmount,
        pastCommission: Object.values(pastCommission)
    }
}

function _contributorsAndNonContributors(props) {
    if (!props.total[0])
        return {
            contributors: props.total.numContributingMembers,
            nonContributors: props.total.numNonContributingMembers
        }
    else return {
        contributors: props.total[0].numContributingMembers,
        nonContributors: props.total[0].numNonContributingMembers
    }
}

function _searchMember(memberName, props, state) {
    //const memberList = props.match.params.product ? state.totalMembers : props.memberList
    let totalMembers = []
    let searchResult = []

    if (props.memberList && memberName) {
        if (state.contributing !== "all")
            totalMembers = state.memberList.filter(member => member.hasContributions === state.contributing).map(member => member)
        else
            totalMembers = state.memberList
        searchResult = totalMembers.filter(member =>
            member.firstName.toLowerCase().includes(memberName.toLowerCase()) ||
            member.lastName.toLowerCase().includes(memberName.toLowerCase()) ||
            (member.firstName.toLowerCase() + " " + member.lastName.toLowerCase()).includes(memberName.toLowerCase()))
            .map(member => member)
        // this.setState({searchResult: this.searchResult})
        return searchResult
    }
    if (!memberName) {
        return (
            (state.contributorsFiltered && state.contributorsFiltered.length !== 0) ?
                state.contributorsFiltered : state.totalMembers
        )
        // this.setState({
        //     searchResult: 
        //     (state.contributorsFiltered && state.contributorsFiltered.length !== 0) ? 
        //         state.contributorsFiltered : state.totalMembers})
    }
}

const _adviserPortalHome = {
    _adviserDahsboardBodyInDetail, _totalMembersInDetail, _totalFumInDetail,
    _commissionPaymentDetails, _commissionPaymentDetailsGroup, _contributorsAndNonContributors, _searchMember
}

export default _adviserPortalHome;